import DesignTokens from '@tableau/design-tokens';
import { NotificationAlertLowShieldOutlineBaseIconRaw } from '@tableau/icons/NotificationAlertLowShieldOutlineBaseIcon/raw';
import { ReactiveRawIconRegistry } from '@tableau/icons/reactive';
import { UserSingleBaseIconRaw } from '@tableau/icons/UserSingleBaseIcon/raw';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-icon-spinner', {
    display: 'inline-block',
    backgroundImage: 'url(img/busy.gif?1_0_9606_yabs0uv7t1h)',
    backgroundRepeat: 'no-repeat',
    width: '10px',
    height: '10px',
});

cssRule('.tb-icon-spinner-large, .tb-icon-spinner-large-alternate', {
    display: 'inline-block',
    backgroundImage: 'url(img/busy_large.gif?1_0_9606_yabs0uv7t1h)',
    backgroundRepeat: 'no-repeat',
    width: '32px',
    height: '32px',
});

cssRule('.tb-icon-spinner-large-alternate', {
    backgroundImage: 'url(img/busy_alternate_large.gif?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-loading-indicator', {
    backgroundImage: 'url(img/busy_large.gif?1_0_9606_yabs0uv7t1h)',
    backgroundRepeat: 'no-repeat',
    width: '32px',
    height: '32px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: '-16px',
    marginTop: '-16px',
});

cssRule('.tb-icon-alert', {
    backgroundRepeat: 'no-repeat',
    width: '19px',
    height: '19px',
    display: 'inline-block',
    backgroundImage: 'url(img/alert_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-alert:hover', {
    backgroundImage: 'url(img/alert_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-alert-list-header', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationAlertLowShieldOutlineBaseIconRaw, 18)})`,
    display: 'inline-block',
    backgroundRepeat: 'no-repeat',
    width: '19px',
    height: '19px',
});

cssRule('.tb-icon-server-alert-list-suspended', {
    backgroundImage: 'url(img/server_alert_list_suspended.svg?1_0_9606_yabs0uv7t1h)',
    display: 'inline-block',
    backgroundRepeat: 'no-repeat',
    width: '19px',
    height: '19px',
});

cssRule('.tb-icon-server-alert-list-suspended:hover', {
    backgroundImage: 'url(img/server_alert_list_suspended_active.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-server-alert-list-suspended-active', {
    backgroundImage: 'url(img/server_alert_list_suspended_active.svg?1_0_9606_yabs0uv7t1h)',
    display: 'inline-block',
    backgroundRepeat: 'no-repeat',
    width: '19px',
    height: '19px',
});

cssRule('.tb-icon-dialogs-status-alert', {
    backgroundImage: 'url(img/dialogs_status_alert.svg?1_0_9606_yabs0uv7t1h)',
    display: 'inline-block',
    backgroundRepeat: 'no-repeat',
    width: '19px',
    height: '19px',
});

cssRule('.tb-icon-dialogs-status-alert:hover', {
    backgroundImage: 'url(img/dialogs_status_alert_active.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-dialogs-status-alert-active', {
    backgroundImage: 'url(img/dialogs_status_alert_active.svg?1_0_9606_yabs0uv7t1h)',
    display: 'inline-block',
    backgroundRepeat: 'no-repeat',
    width: '19px',
    height: '19px',
});

cssRule('.tb-popup-menu:focus .tb-icon-help-menu', {
    backgroundImage: 'url(img/help_header_icon.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-popup-menu:focus .tb-action-icon', {
    backgroundImage: 'url(img/actions_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-popup-menu', {
    position: 'relative',
});

cssRule('.tb-popup-menu:focus', {
    outline: 0,
});

cssRule('.tb-popup-menu.tb-popup-menu-inline', {
    display: 'inline-block',
});

cssRule('.tb-popup-menu.tb-popup-menu-inline >div', {
    display: 'inline-block',
});

cssRule('.tb-popup-menu:focus .tb-popup-menu-button', {
    border: '1px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.hover, '#666'),
});

cssRule('.tb-popup-menu:focus .tb-popup-menu-button >.tb-text', {
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-popup-menu:focus .tb-popup-menu-button >.tb-line', {
    backgroundColor: applyColor(DesignTokens.color.elevation.border.default.subtle, '#666'),
});

cssRule('.tb-popup-menu:focus .tb-popup-menu-button >.tb-arrow', {
    background: 'url(img/dropdown_arrow_pressed.svg?1_0_9606_yabs0uv7t1h) no-repeat',
});

cssRule('.tb-popup-menu', {
    position: 'relative',
});

cssRule('.tb-popup-menu:focus', {
    outline: 0,
});

cssRule('.tb-popup-menu.tb-popup-menu-inline', {
    display: 'inline-block',
});

cssRule('.tb-popup-menu.tb-popup-menu-inline >div', {
    display: 'inline-block',
});

cssRule('.tb-popup-menu:focus .tb-popup-menu-button', {
    border: '1px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.hover, '#666'),
});

cssRule('.tb-popup-menu:focus .tb-popup-menu-button >.tb-text', {
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-popup-menu:focus .tb-popup-menu-button >.tb-line', {
    backgroundColor: applyColor(DesignTokens.color.elevation.border.default.subtle, '#666'),
});

cssRule('.tb-popup-menu:focus .tb-popup-menu-button >.tb-arrow', {
    background: 'url(img/dropdown_arrow_pressed.svg?1_0_9606_yabs0uv7t1h) no-repeat',
});

cssRule('.tb-action-icon', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundImage: 'url(img/actions_normal.svg?1_0_9606_yabs0uv7t1h)',
    backgroundSize: '19px 19px',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    width: '37px',
    height: '37px',
    cursor: 'pointer',
});

cssRule('.tb-action-icon:hover', {
    backgroundImage: 'url(img/actions_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-action-icon-svg', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundImage: 'url(img/thumbnail_ellipsis_normal.svg?1_0_9606_yabs0uv7t1h)',
    backgroundSize: 'contain',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    cursor: 'pointer',
});

cssRule('.tb-action-icon-svg:hover', {
    backgroundImage: 'url(img/thumbnail_ellipsis_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-drop-down-icon', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundImage: 'url(img/down_arrow_normal.svg?1_0_9606_yabs0uv7t1h)',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    width: '19px',
    height: '19px',
    cursor: 'pointer',
});

cssRule('.tb-drop-down-icon:hover', {
    backgroundImage: 'url(img/column_dropdown_arrow_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-help', {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '17px',
    height: '17px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url(img/info_normal.svg?1_0_9606_yabs0uv7t1h)',
    backgroundSize: '19px 19px',
});

cssRule('.tb-icon-help:hover', {
    backgroundImage: 'url(img/info_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-info', {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '17px',
    height: '17px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '19px 19px',
    backgroundImage: 'url(img/info_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-info:hover', {
    backgroundImage: 'url(img/info_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-info-no-hover', {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '17px',
    height: '17px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '19px 19px',
    backgroundImage: 'url(img/info_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-permissions-info', {
    display: 'table-cell',
    verticalAlign: 'bottom',
    width: '17px',
    height: '17px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url(img/info_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-project-permissions-info', {
    display: 'inline-block',
    verticalAlign: 'text-bottom',
    marginLeft: '3px',
    width: '17px',
    height: '17px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url(img/info_normal.svg?1_0_9606_yabs0uv7t1h)',
    backgroundSize: '19px 19px',
});

cssRule('.tb-icon-project-permissions-info:hover', {
    backgroundImage: 'url(img/info_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-checkmark', {
    backgroundImage: 'url(img/check_14px-small.svg?1_0_9606_yabs0uv7t1h)',
    width: '17px',
    height: '17px',
    backgroundRepeat: 'no-repeat',
    display: 'inline-block',
});

cssRule('.tb-place-action-icon', {
    boxSizing: 'border-box',
    height: '31px',
    width: '31px',
    backgroundSize: '19px 19px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    padding: '6px',
});

cssRule('.tb-place-action-icon:hover', {
    padding: 0,
});

cssRule('.tb-new-workbook-icon', {
    backgroundImage: 'url(img/new_workbook_small_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-new-workbook-icon:hover, .tb-new-workbook-icon:focus', {
    backgroundImage: 'url(img/new_workbook_small_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-edit-workbook-icon', {
    backgroundImage: 'url(img/edit_small_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-edit-workbook-icon:hover, .tb-edit-workbook-icon:focus', {
    backgroundImage: 'url(img/edit_small_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-download-icon', {
    backgroundImage: 'url(img/download_small_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-download-icon:hover, .tb-download-icon:focus', {
    backgroundImage: 'url(img/download_small_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-rename-icon', {
    backgroundImage: 'url(img/rename_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-rename-icon:hover, .tb-rename-icon:focus', {
    backgroundImage: 'url(img/rename_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-run-now-icon', {
    backgroundImage: 'url(img/run_now_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-run-now-icon:hover, .tb-run-now-icon:focus', {
    backgroundImage: 'url(img/run_now_small_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-refresh-icon', {
    backgroundImage: 'url(img/refresh_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-refresh-icon:hover, .tb-refresh-icon:focus', {
    backgroundImage: 'url(img/refresh_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-rename-editable-text-icon', {
    paddingLeft: '31px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '6px center',
    backgroundImage: 'url(img/rename_normal.svg?1_0_9606_yabs0uv7t1h)',
    backgroundSize: '17px 17px',
});

cssRule('.tb-rename-editable-text-icon:hover, .tb-rename-editable-text-icon:focus', {
    backgroundImage: 'url(img/rename_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-link-datasource, .tb-link-flow, .tb-link-group, .tb-link-project, .tb-link-schedule, .tb-link-site, .tb-link-user, .tb-link-view, .tb-link-workbook', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    paddingLeft: '23px',
});

cssRule('.tb-link-datasource, .tb-grid-icon-datasource', {
    backgroundImage: 'url(img/data_source_content_type_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-grid-icon-datasource, .tb-grid-icon-flow, .tb-grid-icon-group, .tb-grid-icon-project, .tb-grid-icon-published-connection, .tb-grid-icon-schedule, .tb-grid-icon-site, .tb-grid-icon-user, .tb-grid-icon-view, .tb-grid-icon-view-attached-pdf, .tb-grid-icon-view-attached-all, .tb-grid-icon-workbook, .tb-grid-icon-workbook-attached-pdf, .tb-grid-icon-workbook-attached-all, .tb-grid-icon-alert-suspended', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    width: '23px',
    height: '37px',
});

cssRule('.tb-grid-icon-datasource.tb-grid-icon-small-row, .tb-grid-icon-flow.tb-grid-icon-small-row, .tb-grid-icon-group.tb-grid-icon-small-row, .tb-grid-icon-project.tb-grid-icon-small-row, .tb-grid-icon-published-connection.tb-grid-icon-small-row, .tb-grid-icon-schedule.tb-grid-icon-small-row, .tb-grid-icon-site.tb-grid-icon-small-row, .tb-grid-icon-user.tb-grid-icon-small-row, .tb-grid-icon-view.tb-grid-icon-small-row, .tb-grid-icon-view-attached-pdf.tb-grid-icon-small-row, .tb-grid-icon-view-attached-all.tb-grid-icon-small-row, .tb-grid-icon-workbook.tb-grid-icon-small-row, .tb-grid-icon-workbook-attached-pdf.tb-grid-icon-small-row, .tb-grid-icon-workbook-attached-all.tb-grid-icon-small-row, .tb-grid-icon-alert-suspended.tb-grid-icon-small-row', {
    height: '26px',
});

cssRule('.tb-link-flow, .tb-grid-icon-flow', {
    backgroundImage: 'url(img/flow_content_type_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-link-group, .tb-grid-icon-group', {
    backgroundSize: '17px 17px',
    backgroundImage: 'url(img/group_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-link-project, .tb-grid-icon-project', {
    backgroundImage: 'url(img/project_content_type_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-grid-icon-published-connection', {
    backgroundImage: 'url(img/server_connection_18px-large.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-link-schedule, .tb-grid-icon-schedule', {
    backgroundSize: '17px 17px',
    backgroundImage: 'url(img/schedule_content_type_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-grid-icon-schedule-stylish', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    width: '23px',
    height: '44px',
    backgroundSize: '17px 17px',
    backgroundImage: 'url(img/schedule_content_type_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-link-site, .tb-grid-icon-site', {
    backgroundSize: '17px 17px',
    backgroundImage: 'url(img/site_content_type_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-grid-icon-site-stylish', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundSize: '20px 20px',
    backgroundImage: 'url(img/site_content_type_small.svg?1_0_9606_yabs0uv7t1h)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    width: '26px',
    height: '44px',
});

cssRule('.tb-link-user, .tb-grid-icon-user', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(UserSingleBaseIconRaw, 18)})`,
});

cssRule('.tb-link-view, .tb-grid-icon-view', {
    backgroundImage: 'url(img/view_content_type_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-grid-icon-alert-suspended', {
    backgroundImage: 'url(img/server_alert_list_suspended.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-grid-icon-alert-suspended:hover', {
    backgroundImage: 'url(img/server_alert_list_suspended_active.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-link-workbook, .tb-grid-icon-workbook', {
    backgroundImage: 'url(img/workbook_content_type_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-grid-icon-view-attached-pdf', {
    backgroundImage: 'url(img/content_type_attached_pdf_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-grid-icon-view-attached-all', {
    backgroundImage: 'url(img/view_content_type_attached_all_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-grid-icon-workbook-attached-pdf', {
    backgroundImage: 'url(img/content_type_attached_pdf_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-grid-icon-workbook-attached-all', {
    backgroundImage: 'url(img/workbook_content_type_attached_all_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-datasource-icon, .tb-icon-datasource-embedded, .tb-icon-datasource-published, .tb-icon-datasource-connection-file, .tb-icon-datasource-connection-external, .tb-icon-datasource-connection-tableau', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    width: '23px',
    height: '37px',
});

cssRule('.tb-icon-datasource-embedded', {
    backgroundSize: '17px 17px',
    backgroundImage: 'url(img/data_source_embedded_content_type_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-datasource-published', {
    backgroundSize: '17px 17px',
    backgroundImage: 'url(img/data_source_content_type_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-datasource-connection-file', {
    backgroundSize: '17px 17px',
    backgroundImage: 'url(img/file_connection_type_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-datasource-connection-external', {
    backgroundSize: '17px 17px',
    backgroundImage: 'url(img/external_server_connection_type_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-datasource-connection-tableau', {
    backgroundSize: '17px 17px',
    backgroundImage: 'url(img/tableau_server_connection_type_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-process-status', {
    display: 'inline-block',
    width: '21px',
    height: '20px',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
});


cssRule('.tb-status-legend-item', {
    marginRight: '12px',
});

cssRule('.tb-status-legend-item .tb-icon-process-status', {
    display: 'inline-block',
    height: '23px',
    marginRight: '3px',
});

cssRule('.tb-row-with-icon-on-right', {
    display: 'inline-flex',
    paddingRight: '29px',
    position: 'relative',
});

cssRule('.tb-row-icon-on-right', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 'auto',
    width: '23px',
    height: '23px',
    backgroundPosition: 'center center',
});

cssRule('.tb-row-icon-on-right-react', {
    position: 'absolute',
    top: '-5px',
    right: 0,
    bottom: 0,
    left: 'auto',
    width: '23px',
    height: '23px',
    backgroundPosition: 'center center',
});

cssRule('.tb-header-row-icon', {
    height: '35px',
    backgroundPosition: 'center center',
});

cssRule('.tb-header-row-icon-centered', {
    backgroundPosition: 'center center',
    padding: '0px 10px 0px 30px',
    boxSizing: 'border-box',
    height: '24px',
});

cssRule('.tb-dropdown-label-icon-on-right', {
    marginLeft: '3px',
    padding: '0px 2px 2px 0px',
});

cssRule('.tb-white-icon-permissions-locked', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundImage: 'url(img/locked_white_normal.svg?1_0_9606_yabs0uv7t1h)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    height: '19px',
    width: '19px',
});

cssRule('.tb-white-icon-permissions-unlocked', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundImage: 'url(img/unlocked_white_normal.svg?1_0_9606_yabs0uv7t1h)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    height: '19px',
    width: '19px',
});

cssRule('.tb-white-icon-permissions-mixed', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundImage: 'url(img/locked_mixed_white_normal.svg?1_0_9606_yabs0uv7t1h)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    height: '19px',
    width: '19px',
});

cssRule('.tb-gray-icon-permissions-locked', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundImage: 'url(img/locked_gray_normal.svg?1_0_9606_yabs0uv7t1h)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    height: '19px',
    width: '19px',
});

cssRule('.tb-gray-icon-permissions-unlocked', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundImage: 'url(img/unlocked_gray_normal.svg?1_0_9606_yabs0uv7t1h)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    height: '19px',
    width: '19px',
});

cssRule('.tb-gray-icon-permissions-mixed', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundImage: 'url(img/locked_mixed_gray_normal.svg?1_0_9606_yabs0uv7t1h)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    height: '19px',
    width: '19px',
});

cssRule('.tb-section-open-icon', {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '19px',
    height: '19px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url(img/panel_show_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-section-open-icon:hover', {
    backgroundImage: 'url(img/panel_show_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-section-close-icon', {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '19px',
    height: '19px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url(img/panel_hide_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-section-close-icon:hover', {
    backgroundImage: 'url(img/panel_hide_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-dialogs-workbook', {
    display: 'inline-block',
    verticalAlign: 'top',
    height: '17px',
    width: '17px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url(img/dialogs_workbook.svg?1_0_9606_yabs0uv7t1h)',
    paddingLeft: '3px',
});

cssRule('.tb-dialogs-warning', {
    display: 'inline-block',
    verticalAlign: 'top',
    height: '17px',
    width: '17px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url(img/dialogs_warning.svg?1_0_9606_yabs0uv7t1h)',
    paddingLeft: '3px',
});

cssRule('.tb-data-pane-workbook-icon, .tb-data-pane-datasource-icon, .tb-data-pane-datasource-extract-icon, .tb-data-pane-datasource-cube-icon, .tb-prep-flow-icon', {
    height: '17px',
    width: '17px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url(img/published_type_workbook.png?1_0_9606_yabs0uv7t1h)',
    paddingLeft: '3px',
});

cssRule('.tb-data-pane-datasource-extract-icon', {
    backgroundImage: 'url(img/published_type_datasource_extract.png?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-data-pane-datasource-cube-icon', {
    backgroundImage: 'url(img/published_type_datasource_cube.png?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-prep-flow-icon', {
    backgroundImage: 'url(img/published_type_flow.png?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-prep-flow-overview-history-status-icon, .tb-prep-flow-overview-history-status-pending-icon, .tb-prep-flow-overview-history-status-inprogress-icon, .tb-prep-flow-overview-history-status-success-icon, .tb-prep-flow-overview-history-status-failed-icon, .tb-prep-flow-overview-history-status-cancelled-icon, .tb-prep-flow-overview-run-now-icon', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundSize: '17px 17px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    width: '23px',
    height: '37px',
});

cssRule('.tb-prep-flow-overview-history-status-pending-icon', {
    backgroundImage: 'url(img/flow_run_pending.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-prep-flow-overview-history-status-inprogress-icon', {
    backgroundImage: 'url(img/flow_run_in_progress.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-prep-flow-overview-history-status-success-icon', {
    backgroundImage: 'url(img/flow_run_succeeded.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-prep-flow-overview-history-status-failed-icon', {
    backgroundImage: 'url(img/flow_run_error.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-prep-flow-overview-history-status-cancelled-icon', {
    backgroundImage: 'url(img/flow_run_cancelled.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-prep-flow-overview-run-now-icon', {
    backgroundImage: 'url(img/run_now_small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-prep-flow-overview-run-now-icon:hover', {
    backgroundImage: 'url(img/run_now_small_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-published-connection-policies-applied', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundSize: '17px 17px',
    backgroundImage: 'url(img/shield_14px_small.svg?1_0_9606_yabs0uv7t1h)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    width: '23px',
    height: '37px',
});

cssRule('.tb-published-connection-policies-applied-metadata', {
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url(img/shield_14px_small.svg?1_0_9606_yabs0uv7t1h)',
    backgroundPosition: 'left center',
});

cssRule('.tb-icon-process-status-active', {
    backgroundImage: 'url(img/node-status-active.png?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-process-status-busy', {
    backgroundImage: 'url(img/node-status-busy-animated.gif?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-status-legend-item > .tb-icon-process-status-busy', {
    backgroundImage: 'url(img/node-status-busy.png?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-process-status-down', {
    backgroundImage: 'url(img/node-status-down.png?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-process-status-passive', {
    backgroundImage: 'url(img/node-status-passive.png?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-process-status-unlicensed', {
    backgroundImage: 'url(img/node-status-unlicensed.png?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-process-status-external', {
    backgroundImage: 'url(img/node-status-external.png?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-icon-process-status-statusnotavailable', {
    backgroundImage: 'url(img/node-status-unavailable.png?1_0_9606_yabs0uv7t1h)',
});

